export default "__VITE_ASSET__Cb7w0jtK__"